/** Formatação e parsing de dinheiro em pt-BR (compartilhado pelas calculadoras). */

/** Formata número como moeda BRL: 1234.5 → "R$ 1.234,50". */
export function brl(n: number): string {
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/** Formata percentual: 30 → "30%" (com casas opcionais). */
export function pct(n: number, casas = 0): string {
  return `${n.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })}%`
}

/**
 * Converte texto em número, tolerante a pt-BR e en.
 * Aceita "1.234,56" (pt-BR), "1234.56" (en), "1.234.567" (milhar), "1234".
 */
export function parseValor(s: string | number): number {
  if (typeof s === 'number') return Number.isFinite(s) ? s : 0
  let t = String(s).trim()
  if (!t) return 0

  if (t.includes(',')) {
    // pt-BR: ponto é milhar, vírgula é decimal
    t = t.replace(/\./g, '').replace(',', '.')
  } else if ((t.match(/\./g) || []).length > 1) {
    // múltiplos pontos sem vírgula = separador de milhar
    t = t.replace(/\./g, '')
  }
  // caso restante (um ou zero ponto, sem vírgula): trata o ponto como decimal

  const n = parseFloat(t)
  return Number.isFinite(n) ? n : 0
}

/** Filtra a digitação de um campo de dinheiro: só dígitos, vírgula e ponto. */
export function sanitizeMoneyInput(s: string): string {
  return s.replace(/[^\d.,]/g, '')
}
